// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1njkZ","choiceBoxes":"toolbarselects_choiceBoxes__3iOah","simpleField":"toolbarselects_simpleField__3rmiR"};